import { Dictionary } from "@/types/Dictionary";
import { useUtils } from "./useUtils";

export function useCsv() {
  const { isNullOrUndefined } = useUtils();

  async function readCsvFile<T = Dictionary<string>>(
    location: string,
  ): Promise<null | T[]> {
    const now = Date.now();
    const response = await fetch(`${location}?${now}`);
    if (!response.ok) {
      throw new Error("Response not OK");
    }
    const responseText: string = await response.text();
    const responseLines: string[] = responseText.split(/\r?\n/);
    const csvData: string[][] = responseLines.map((line: string) =>
      line.split(";"),
    );
    const headers = csvData.shift();
    if (isNullOrUndefined(headers)) {
      return null;
    }
    return csvData.map((line: string[]) =>
      Object.fromEntries(line.map((value, index) => [headers[index], value])),
    ) as unknown as T[];
  }

  return { readCsvFile };
}
